import { Sprite, Text, Container } from 'pixi.js'
import { FT, Scene, Spine, entitify } from 'ft'
import { Widget } from 'ft/components'
import Dialog from '#/components/Dialog'
import store from '#/store'
import hooks from '#/hooks'
import bgm from '#/bgm'
import track from '#/track'

const $SPINE = 'spine.SC01'
const $buttonLogout = 'intro-button-logout'
const $buttonNext = 'share-button-next'
FT.rm.addSpine($SPINE)
FT.rm.addImage($buttonLogout)
FT.rm.addImage($buttonNext)

class Preloader extends Scene {
  constructor(name) {
    super(name)

    track(`${store.type}-scene1`, `${store.type}-场景1`)

    hooks.renderLoginInfo = this.renderLoginInfo
    this.render()
  }

  render = () => {
    bgm.env.play()
    bgm.playIntro()

    this.initSpine()
    this.initDialog()

    this.playAnimations()
    this.renderLoginInfo()
  }

  initSpine() {
    const SPINE = new Spine(FT.rm.spine($SPINE))
    this.SPINE = SPINE
    SPINE.scale.set(0.5, 0.5)
    SPINE.x = FT.stage.centerX
    SPINE.y = FT.stage.centerY
    const LOOP_MAIN = SPINE.state.setAnimation(1, 'Loop', true)
    const LOOP_SNOW = SPINE.state.setAnimation(2, 'Snow_Loop', true)
    const LOOP_SMOKE = SPINE.state.setAnimation(3, 'Smoke_Loop', true)
    const LOOP_TREE = SPINE.state.setAnimation(4, 'Tree_Loop', true)
    this.LOOP_MAIN = LOOP_MAIN
    this.LOOP_SNOW = LOOP_SNOW
    this.LOOP_SMOKE = LOOP_SMOKE
    this.LOOP_TREE = LOOP_TREE
    this.pauseAnimations()
    this.addChild(SPINE)
  }

  pauseAnimations() {
    this.LOOP_MAIN.timeScale = 0
    this.LOOP_SNOW.timeScale = 0
    this.LOOP_SMOKE.timeScale = 0
    this.LOOP_TREE.timeScale = 0
  }

  playAnimations() {
    const onComplete = async track => {
      const { name } = track.animation
      if (name === 'Intro') {
        this.LOOP_MAIN.timeScale = 1
        this.LOOP_SNOW.timeScale = 1
        this.LOOP_SMOKE.timeScale = 1
        this.LOOP_TREE.timeScale = 1
        this.showDialog()
      }
    }
    this.SPINE.state.addListener({ complete: onComplete })
    this.SPINE.state.setAnimation(0, 'Intro')
  }

  initDialog() {
    const dialog = new Dialog(
      '冰天雪地...天寒地冻...',
      { align: 'center', theme: 'cold' },
      this.nextScene
    )
    dialog.visible = false
    this.dialog = dialog
    this.addChild(dialog)
  }

  showDialog() {
    this.dialog.visible = true
  }

  renderLoginInfo = () => {
    const { rm } = FT

    const loginInfo = entitify(new Container())
    loginInfo.addComponent(new Widget({ top: 20, right: 20 }))
    FT.ecs.addEntity(loginInfo)

    const user = new Text(`${store.username} | ${store.region}`, {
      fontFamily: 'sans-serif',
      fontSize: 30,
      fill: 0xffffff,
      align: 'center',
    })
    user.anchor.set(1, 0)
    user.position.set(-140, 22)
    loginInfo.addChild(user)

    const buttonLogout = new Sprite(rm.texture($buttonLogout))
    buttonLogout.interactive = true
    buttonLogout.anchor.set(1, 0)
    buttonLogout.on('pointerup', () => {
      loginInfo.parent.removeChild(loginInfo)
      hooks.logout()
    })
    loginInfo.addChild(buttonLogout)
    this.addChild(loginInfo)
  }

  nextScene = () => {
    FT.sm.load('porch', { transition: true })
  }
}

export default Preloader
